import { Icon } from './Icon';

/**
 * Шеврон строки: вправо — «внутрь раздела», влево — возврат.
 *
 * Оба направления это ОДНА фигура, отражённая: узкий высокий шеврон 8×13
 * линией в 1.4, как в макетах. Держать их порознь уже пробовали — возврат
 * рисовал свой `<svg>` руками, стрелка строки жила в общей квадратной коробке,
 * и вышла приземистой и втрое тоньше: она читалась как невыкрашенная, хотя
 * цвет был тот самый.
 */
export function ChevronIcon({
  size = 13,
  direction = 'right',
}: {
  size?: number;
  direction?: 'right' | 'left';
}) {
  return (
    <Icon size={size} box={[8, 13]} strokeWidth={1.4}>
      <path d={direction === 'right' ? 'M1 1 L6.5 6.5 L1 12' : 'M7 1 L1.5 6.5 L7 12'} />
    </Icon>
  );
}
